export default __webpack_public_path__ + "static/media/19_gallery.11732c51.jpg";